import { DEFAULT_SERVER_PATH, REPORT_API } from "src/constant";
import { pathJoin } from "./url";

export default function formatReportPath(path: string): string {
  let retPath = path;
  const protocol = location.protocol;
  if (!path) {
    retPath = `https://${location.hostname}${DEFAULT_SERVER_PATH}`;
  }
  // 不包含斜杠"/"，判断为域名配置，进行默认补全逻辑
  if (!/\//.test(retPath)) {
    retPath = `https://${retPath}${DEFAULT_SERVER_PATH}`
  }
  // 双斜杠开头的配置，补全协议头
  if(/^\/\/[^\/]/.test(retPath)) {
    retPath = protocol + retPath;
  }
  // 单斜杠开头的配置，补全协议与域名
  if (/^\/[^\/]/.test(retPath)) {
    retPath = `${location.origin}${retPath}`;
  }
  if(!/^(https?:)?\/\//.test(retPath)) {
    retPath = `${protocol}//${retPath}`;
  }
  // 非斜杠结尾，添补斜杠结束
  if(!/\/$/.test(retPath)) {
    retPath = retPath + '/';
  }
  return pathJoin(retPath, REPORT_API);
}
